import * as React from 'react';
import styled from 'styled-components';
import { palette } from '../../theme/colors';
import Arrow from '../../assets/icons/chevron-right--yellow.svg';
import { isArray } from 'lodash';

const SContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  border-bottom: 1px solid ${palette.queenBlue};

  padding: 0.9375rem 0rem;
`;
const SRightContaoner = styled.div`
  display: flex;
  align-items: center;
  width: 67%;
  padding-right: 0.75rem;
`;
const SSummaryText = styled.p`
  flex-grow: 1;

  color: ${palette.white};
  font-family: 'Roboto-Medium';
  font-weight: 500;
  font-size: 0.87rem;
  line-height: 1rem;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const STitle = styled.p`
  font-family: 'Roboto-Regular';
  font-size: 0.75rem;
  line-height: 0.875rem;
  color: ${palette.white};

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

type ISummaryTabProps = {
  title: string;
  summaryText: string | string[];
  className?: string | undefined;
  onTabClick: () => void;

  customEndIcon?: string;
};

export const SummaryTab = (props: ISummaryTabProps) => {
  const { onTabClick, summaryText, title, className, customEndIcon } = props;

  const getSummaryText = (text: string | string[]): string => {
    return isArray(text) ? text.join(', ') : text;
  };

  return (
    <SContainer className={className} onClick={onTabClick} role={`summary-tab-${title}`}>
      <STitle role="title">{title}</STitle>
      <SRightContaoner className={'SRightContaoner'} role="textContainer">
        <SSummaryText role="text">{getSummaryText(summaryText)}</SSummaryText>
        <img role="arrowIcon" src={customEndIcon ? customEndIcon : Arrow} alt="right-arrow" />
      </SRightContaoner>
    </SContainer>
  );
};
